/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AutomationdataSettings} from './AutomationdataSettings';

/**
 * The DataPipelinesBody model module.
 * @module model/DataPipelinesBody
 * @version 1.0.0
 */
export class DataPipelinesBody {
  /**
   * Constructs a new <code>DataPipelinesBody</code>.
   * @alias module:model/DataPipelinesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DataPipelinesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DataPipelinesBody} obj Optional instance to populate.
   * @return {module:model/DataPipelinesBody} The populated <code>DataPipelinesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DataPipelinesBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('tags'))
        obj.tags = ApiClient.convertToType(data['tags'], ['String']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('dataAutomations'))
        obj.dataAutomations = ApiClient.convertToType(data['dataAutomations'], ['String']);
      if (data.hasOwnProperty('settings'))
        obj.settings = AutomationdataSettings.constructFromObject(data['settings']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
DataPipelinesBody.prototype.title = undefined;

/**
 * @member {String} description
 */
DataPipelinesBody.prototype.description = undefined;

/**
 * @member {Array.<String>} tags
 */
DataPipelinesBody.prototype.tags = undefined;

/**
 * @member {Boolean} enabled
 */
DataPipelinesBody.prototype.enabled = undefined;

/**
 * @member {Array.<String>} dataAutomations
 */
DataPipelinesBody.prototype.dataAutomations = undefined;

/**
 * @member {module:model/AutomationdataSettings} settings
 */
DataPipelinesBody.prototype.settings = undefined;

